import React, { useContext, useEffect, useState } from 'react';
import { DataTableComponent } from '../data-table/data-table.component';
import { EmployeesContext } from '../../store';
import { MapperService } from '../../services/mapper/mapper.service';
import { EmployeesService } from '../../services/employees/employees.service';

export default function EmployeesContent(props: any) {
  const {columns, options, sort, pagination, paginate, mode, setViewMode, search, setEmployees, employees, employeesCache, activeFilters, setFilters} = useContext(EmployeesContext);

  const toggleView = () => {
    const viewMode = mode === 'table' ? 'calendar' : 'table';
    setViewMode(viewMode);
  }

  const mapperService = new MapperService();
  const employeesService = new EmployeesService();

  const emptyArr: any = [];

  const [loading, setLoading] = useState(true);

  async function getEmployees() {
    setEmployees(emptyArr);
    setLoading(true);
    const employeeslist = await employeesService.listEmployees();
    const { allEmployees, filters } = await mapperService.employees(employeeslist, activeFilters);
    setFilters(filters);
    setEmployees(allEmployees);
    setLoading(false);
  }

  useEffect(() => {
    getEmployees();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getEmployees();
    // eslint-disable-next-line
  }, [activeFilters]);

  const sortTable = (fieldName: string, sortDirection: string) => {
    const params = {fieldName, sortDirection};
    return sort(params);
  }

  const searchTable = (fieldName: string, searchString: string) => {
    const params = {fieldName, searchString}
    return search(params);
  }

  return (
    <DataTableComponent
      columns={columns}
      data={employees}
      allData={employeesCache}
      options={options}
      mode={mode}
      toggleView={toggleView}
      refresh={getEmployees}
      sort={sortTable}
      search={searchTable}
      loading={loading}
      clickableRow={['employee/details', 'user.id']}
      pagination={pagination}
      paginate={paginate}
      total={employeesCache?.length || 0}
      title='staff'
    />
  );
}
